import {Component, OnDestroy, OnInit} from '@angular/core';
import {RubixDocumentsService} from "../rubix-documents.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit, OnDestroy {

  currentFolderPathList: { id: string; name: string }[] = [];
  loading = true;

  subscriptions: Subscription[] = [];

  constructor(
    public rubixDocumentsService: RubixDocumentsService
  ) { }

  ngOnInit() {
    this.loading = this.rubixDocumentsService.loading;
    this.currentFolderPathList = [...(this.rubixDocumentsService.currentFolderPath || [])];

    this.subscriptions.push(
      this.rubixDocumentsService.notifyNavigationChange$.subscribe(value => {
        this.loading = this.rubixDocumentsService.loading;
        this.currentFolderPathList = [...(this.rubixDocumentsService.currentFolderPath || [])];
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  toFolder(folderId: string, folderName?: string) {
    this.rubixDocumentsService.toFolder(folderId, folderName);
  }

  onClickFolderName(index: number) {
    const folderNode = this.currentFolderPathList[index];
    if (!folderNode) {
      return;
    }

    this.toFolder(folderNode.id, folderNode.name);
  }

  onClickToPrevious() {
    this.rubixDocumentsService.toPreviousFolder();
  }

  onClickToNext() {
    this.rubixDocumentsService.toNextFolder();
  }
}
